// Shrinks photos before they're kept in state / saved in drafts. Phone cameras
// produce 3–5 MB images, and a draft carries every photo on the order, so a
// photo-heavy order could exceed the server's ~30 MB request cap and fail with
// a bare "Network Error". 1800px / 0.85 matches PdfGen's "high" preset, so the
// PDF never loses quality it would otherwise have used.
export const PHOTO_MAX_PX = 1800;
export const PHOTO_QUALITY = 0.85;

// Photos already this small (≈450 KB) are left alone — re-encoding them again
// on every save would only degrade them.
const ALREADY_SMALL_CHARS = 600_000;

export function shrinkDataUrl(dataUrl, maxPx = PHOTO_MAX_PX, quality = PHOTO_QUALITY) {
  if (typeof dataUrl !== 'string' || dataUrl.length < ALREADY_SMALL_CHARS) {
    return Promise.resolve(dataUrl);
  }
  return new Promise(resolve => {
    const img = new Image();
    img.onload = () => {
      const scale = Math.min(1, maxPx / Math.max(img.width, img.height));
      const canvas = document.createElement('canvas');
      canvas.width = Math.round(img.width * scale);
      canvas.height = Math.round(img.height * scale);
      canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
      const out = canvas.toDataURL('image/jpeg', quality);
      resolve(out.length < dataUrl.length ? out : dataUrl);
    };
    // Never lose a photo over this — fall back to the original.
    img.onerror = () => resolve(dataUrl);
    img.src = dataUrl;
  });
}

export async function shrinkItemPhotos(itemPhotos) {
  const entries = await Promise.all(
    Object.entries(itemPhotos || {}).map(async ([key, photos]) =>
      [key, await Promise.all((photos || []).map(p => shrinkDataUrl(p)))])
  );
  return Object.fromEntries(entries);
}

export function shrinkPhotoList(photos) {
  return Promise.all((photos || []).map(p => shrinkDataUrl(p)));
}
